export class Controller {

    $onChanges() {
        this.tooltipKey = ({
            ADMIN: 'sp-addition-source.admin',
            THIRD_PARTY_FACEBOOK: 'sp-addition-source.third-party-facebook',
            USER: 'sp-addition-source.user',
            AZURE_DIRECTORY: 'sp-addition-source.azure-directory',
        })[this.additionSource];

        this.iconClass = ({
            ADMIN: 'text-primary fa fa-lg fa-user',
            THIRD_PARTY_FACEBOOK: 'text-primary fa fa-lg fa-facebook-official',
            USER: 'text-primary far fa-lg fa-user-circle',
            AZURE_DIRECTORY: 'text-primary fa-solid fa-diamond',
        })[this.additionSource];
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-addition-source/sp-addition-source.controller.js